var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"bb-nested-view"},[_c('router-link',{attrs:{"to":"/campaign-editor-home"}},[_vm._v("back")]),_c('h1',[_vm._v("Campaign Sub Route")]),_c('h2',[_vm._v("CONTENT HERE")]),_c('h3',[_vm._v("CONTENT HERE")]),_c('h4',[_vm._v("CONTENT HERE")]),_c('h5',[_vm._v("CONTENT HERE")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }